<template>
  <table width="100%">
    <div id="term-fine-table">
      <div>
        <h3>
          <b>{{ tableTitle }}</b>
        </h3>
        <table>
          <thead>
            <tr>
              <template v-for="(row, index) in data.header">
                <th :key="Math.random() + row" :class="{
                  'index-column': [
                    'plano',
                    'multa',
                    'benefício',
                    'benefício (mês)',
                    'benefício (ano)',
                  ].includes(row.toLowerCase()),
                  'blue-column': [
                    'benefício',
                    'benefício (mês)',
                    'benefício (ano)',
                  ].includes(row.toLowerCase()),
                  'black-column': ['plano', 'multa'].includes(
                    row.toLowerCase()
                  ),
                }" :data-index="index" style="height: 10px">
                  {{ row }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data.body" :key="Math.random() + row" :style="shouldApplyStyle(index)">
              <template v-for="(tdValue, columnIndex) in row">
                <td id="tr-body" v-if="isNaN(tdValue / 2)" :data-index="columnIndex" :key="Math.random() + columnIndex"
                  :class="{
                    'blue-column': [
                      'benefício',
                      'benefício (mês)',
                      'benefício (ano)',
                    ].includes(data.header[columnIndex].toLowerCase()),
                  }">
                  {{ tdValue }}
                </td>
                <td v-else :data-index="columnIndex" :key="Math.random() + columnIndex" :class="{
                  'blue-column': [
                    'benefício',
                    'benefício (mês)',
                    'benefício (ano)',
                  ].includes(data.header[columnIndex].toLowerCase()),
                }">
                  {{ tdValue | currencyFormat }}
                </td>
              </template>
              <td v-if="index === 42" :style="{ 'page-break-before': 'always' }"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import currencyFormat from "../../../assets/filters/currencyFormat";

export default {
  filters: { currencyFormat },
  name: "FineTable",
  data() {
    return {
      tableTitle: "",
      data: {
        header: [],
        body: [],
      },
      indexColumn: 0,
      aux: 0,
      trCount: 0,
    };
  },
  props: {
    type: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      term: "term/term",
      fineTableDataGetter: "fineTable/fineTableDataGetter",
    }),
    totalRowCount() {
      return this.trCount;
    },
    isTableTitle() {
      return this.tableTitle;
    },
  },
  watch: {
    // Use um watcher para atualizar o contador sempre que houver uma alteração nos dados
    "data.body": {
      handler(newVal) {
        this.trCount = newVal.length;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      fetchFineTableData: "fineTable/fetchFineTableData",
    }),

    getClassByIndexColumn(indexColumn) {
      const thEl = document.querySelector(
        'th.index-column[data-index="' + indexColumn + '"]'
      );

      if (thEl !== null) {
        return thEl.getAttribute("class").split(" ")[1];
      }

      return "";
    },
    getThByIndex(index) {
      return document.querySelector(
        '#term-fine-table th[data-index="' + index + '"]'
      );
    },
    getTdByIndex(index) {
      return document.querySelectorAll(
        '#term-fine-table td[data-index="' + index + '"]'
      );
    },
    copyClassFromTH() {
      const tdEl = document.querySelectorAll("#term-fine-table td[data-index]");

      for (let i = 0; i < tdEl.length; i++) {
        const el = tdEl[i];
        const dataIndex = el.getAttribute("data-index");
        if (dataIndex) {
          const thEl = this.getThByIndex(dataIndex);
          if (thEl !== null) {
            const classAttr = thEl.getAttribute("class");
            el.setAttribute("class", classAttr);
          }
        }
      }
    },

    shouldApplyStyle(rowIndex) {
      const validatingType = this.type === 'smp_loyalty_postpaid_device';
      return {
        'page-break-before': validatingType && rowIndex === 15 ? 'always' : ''
      };
    },

  },
  async mounted() {
    await this.fetchFineTableData(this.type);
    this.tableTitle = this.fineTableDataGetter.name;
    const rows = this.fineTableDataGetter.fines_table_detail;
    const header_ = {
      plan: "Plano",
      benefit: "Benefício",
      month_benefit: "Benefício (Mês)",
      year_benefit: "Benefício (Ano)",
      fine: "Multa",
      "1_month": "1º mês",
      "2_month": "2º mês",
      "3_month": "3º mês",
      "4_month": "4º mês",
      "5_month": "5º mês",
      "6_month": "6º mês",
      "7_month": "7º mês",
      "8_month": "8º mês",
      "9_month": "9º mês",
      "10_month": "10º mês",
      "11_month": "11º mês",
      "12_month": "12º mês",
      "13_month": "13º mês",
    };
    let header = Object.values(header_);

    let rowsAdapt = [];

    rows.map((row, index) => {
      let keys = Object.keys(row);
      rowsAdapt.push([]);
      keys.map((column, colIndex) => {
        if (typeof header_[column] !== "undefined") {
          rowsAdapt[index].push(rows[index][column]);
        }
      });
    });

    let body = [];

    rowsAdapt.map((row, rowIndex) => {
      row.map((column, columnIndex) => {
        if (column === null) {
          header[columnIndex] = "";
        }
      });

      if (row !== null) {
        body[rowIndex] = row.filter((i) => i !== null);
      }
    });

    header = header.filter((i) => i.length);

    this.data.body = body;
    this.data.header = header;

    let setStyleTrBody = null;
    setStyleTrBody = document.getElementById("tr-body");

    if (this.type === "smp_loyalty_postpaid_plan_and_device_device") {
      if (this.data.body.length > 15) {
        setStyleTrBody.setAttribute("style", "page-break-before: always");
      }
    }

    setTimeout(() => {
      this.copyClassFromTH();
    }, 0);
  },
};
</script>

<style lang="scss" >
$blue-tim: #0025da;
$grey: grey;
$black: #2c3e50;

#term-fine-table {
  margin-top: 0px;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 14px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    font-size: 12px;
    color: $grey;
    margin-bottom: 50px;

    thead {
      tr {
        font-weight: bold;
        border-top: 4px solid $blue-tim;
        border-bottom: 4px solid $blue-tim;
        padding-bottom: 5px;

        th {
          padding: 15px 0;
          text-align: center;
          min-width: 60px;

          &:first-child {
            text-align: left;
          }
        }
      }
    }

    tbody {
      tr {
        &:hover {
          transition: all 0.3s ease-out;
          background: rgba(0, 0, 255, 0.05);
        }

        td {
          text-align: center;
          vertical-align: middle;
          height: 40px;
          padding: 0 2px;

          &:first-child {
            text-align: left;
          }
        }
      }
    }
  }

  .blue-column {
    color: $blue-tim;
    font-weight: bold;
  }

  .black-column {
    color: $black;
    font-weight: bold;
  }
}
</style>
